/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */
export interface PersonalizationAttribute {
	name: string;
	value: string | number | boolean | null | undefined;
}

export interface StringifiedPersonalizationAttribute {
	name: string;
	value: string;
}

export function stringifyPersonalizationAttributes<T extends PersonalizationAttribute>(
	attributes: T[] | null | undefined,
): StringifiedPersonalizationAttribute[] {
	if (!attributes) {
		return [];
	}

	return attributes.map((attr) => ({
		...attr,
		value: String(attr.value),
	}));
}
